/** @jsx dom */
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _pikaday = require('pikaday');

var _pikaday2 = _interopRequireDefault(_pikaday);

function afterMount(_ref, el) {
	var props = _ref.props;

	new _pikaday2['default']((0, _objectAssign2['default'])(props, { field: el }));
}

function render(_ref2) {
	var props = _ref2.props;
	var id = props.id;
	var name = props.name;

	return (0, _magicVirtualElement2['default'])('input', { id: id, name: name, type: 'text', 'class': ['Calendar', props['class']], autocomplete: 'off' });
}

exports['default'] = { afterMount: afterMount, render: render };
module.exports = exports['default'];
